import { Avatar, List, Skeleton } from '@components'
import { compileImageUri } from '@helpers'
import { ListItemProps, TWardrobeItem } from '@typings'
import { first, last } from 'lodash'
import React from 'react'

/** Component for single item of ItemList. */
const ItemListRow: React.FC<TProps> = ({ item, actions, loading = false }) => {
	const description = `${last(item.categories)?.category?.title} / ${item.brand?.title}`
	const imageSource = compileImageUri(first(item.assets)?.asset, true)

	return (
		<List.Item actions={actions}>
			<Skeleton avatar title={false} loading={loading} active>
				<List.Item.Meta avatar={<Avatar src={imageSource} />} title={item.name} description={description} />
				<div>{item.id}</div>
			</Skeleton>
		</List.Item>
	)
}

type TProps = {
	/** Single wardrobe item.  */
	item: TWardrobeItem
	/** Set of action for list item. */
	actions: ListItemProps['actions']
	/** Loading item status. If one equals to false then Skeleton will be displayed. */
	loading?: boolean
}

export default React.memo(ItemListRow)
